<template>
	<div class="home">
		<HeaderBar :title="title" :leftArrow="false"></HeaderBar>
		<div class="center-box">
			<div>
				<van-form @submit="onSubmit" ref="form">
					<van-cell-group>
						<!-- <EmployerSelect label="医院名称" :selectkey.sync="form.bq001.companyGuid"
							:secondkey.sync="form.bq001.departmentGuid" required></EmployerSelect>
						<DepartmentSelect label="医生科室" :key="form.bq001.companyGuid + 'c'"
							:selectkey.sync="form.bq001.departmentGuid" :hosId="form.bq001.companyGuid"
							:secondkey.sync="form.bq001.bq001043" required></DepartmentSelect> -->
						<!-- <DepartmentUserSelect :key="form.bq001.departmentGuid + 'd'" label="项目医生"
							:selectkey.sync="form.bq001.bq001043" :parentId="form.bq001.departmentGuid" required>
						</DepartmentUserSelect> -->
							<FormNormalInput label="医院名称" v-model="userModel.employerName" readonly />
							<FormNormalInput label="项目医生" v-model="form.bq001.bq001044" readonly />
						
						<FormNormalInput label="医生电话" v-model="form.bq001.bq001007" readonly />
						<FormNormalInput label="资料校核员" v-model="form.bq001.extend2" v-show="false"
							placeholder="协助医生检查资料完整性的志愿者" />
						<FormNormalInput label="患者姓名缩写" v-model="form.bq001.bq001002" required
							placeholder='例："张三"缩写为“ZS”' />
						<FormNormalInput label="筛选编号" v-model="form.bq001.bq001018" placeholder="中心编号+流水号" v-show="false" />
						<StaticSingleSelect label="性别" :selectkey.sync="form.bq001.bq001003" :list="sexList">
						</StaticSingleSelect>
						<DateSelect v-model="form.bq001.bq001004" label="出生日期" required placeholder="请选择出生日期">
						</DateSelect>
						<DateSelect v-model="form.bq001.bq001040" label="治疗日期" required placeholder="请选择治疗日期" timeMode="defalutYear" :yearDiff="-5">
						</DateSelect>
						<FormNormalInput label="治疗时年龄" v-model="form.bq001.extend3" type="digit" readonly />

						<FormNormalUpload ref="normalUpload" :infoGuid="form.bq001.guid" label="附件" v-show="showInDate"
							emptyMsg="暂无附件"></FormNormalUpload>
					</van-cell-group>
					<div style="height: 0.5rem;"></div>
					<div style="margin: 16px;">
						<!--            <van-button block type="info" @click="submit">
              保存
            </van-button> -->
						<SaveButton :url="saveUrl" ref="btnSave" back="0" @saveSucess="saveSucess"
							:editMode="form.bq001.guid != ''" class="hide">保存
						</SaveButton>
						<van-button block type="info" @click="SaveInfo(0)">保存</van-button>
					</div>
					<van-overlay :show="showOverlay" class="overlay-box">
						<div class="blockBox">
							<van-loading size="50" vertical color="#1989fa">保存数据...</van-loading>
						</div>
					</van-overlay>
				</van-form>
			</div>
			<van-popup v-model="showInDialog" position="right" :style="{ width: '100%', 'height': '90%' }" :close-on-click-overlay="false">
				<HeaderBar title="病例报告表入选标准说明" fixed></HeaderBar>
				<div class="center-box">
					<van-divider class="divide-line" style="margin-top: 1rem;">入选标准</van-divider>
					<div style="margin: 16px; font-size: 0.9rem;">
						符合以下所有条件的患者可进入本研究。<br><br>
						（1）临床诊断为慢性丙肝，开始治疗前HCV RNA阳性；<br><br>
						（2）接受磷酸依米他韦胶囊联合索磷布韦片规范抗病毒治疗。
					</div>

					<van-divider class="divide-line" style="margin-top: 1rem;">排除标准</van-divider>
					<div style="margin: 16px; font-size: 0.9rem;">
						符合以下任一条件的患者不可进入本研究。<br><br>
						（1）既往接受过直接抗病毒药物治疗；<br><br>
						（2）同时参加HCV治疗的其他临床试验（不测试研究用药的试验除外）；<br><br>
						（3）数据缺失且不满足基本统计分析需求。
					</div>

					<div style="margin-top: 2rem;margin-bottom: 2rem; color:red; padding-left: 1rem;">
						※所提供数据均需在病历系统或其他原始资料中可溯源。<br><br>
						※尽可能提供完整信息，其中*为必填项。
					</div>
					<!-- <div style="margin: 16px; display: flex; justify-content: space-between;">

						<van-count-down :time="countDownTime" v-show="true"  format="ss"/>
					</div> -->
					<div style="margin: 16px; display: flex; justify-content: space-between;">
						<van-button block type="danger" plain @click="closeIn()" style="width: 45%;">放弃入组</van-button>
						<van-button block type="info" plain @click="addIn"
							style="width: 45%;">我已知晓</van-button>
					</div>
				</div>
			</van-popup>
		</div>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
import componentsModel from '../base/components.js'
export default {
	name: 's400PatientForm',
	data() {
		return {
			title: '患者添加',
			form: {
				bq001: {
					id: '0', //编号
					guid: '', //guid编号
					companyGuid: '', //单位编号
					departmentGuid: '', //部门编号
					checkStatus: '', //审核状态
					dataStatus: '', //数据状态
					addUid: '', //添加人编号
					addTime: '', //添加时间
					extend1: '', //扩展字段
					extend2: '', //扩展字段
					extend3: '', //扩展字段
					extend4: '', //扩展字段
					extend5: '', //扩展字段
					bq001001: '0', //患者编号
					bq001002: '', //患者姓名
					bq001018: '', //身份证号
					bq001003: '1', //性别,1-男，2-女
					bq001004: '', //出生年月
					bq001012: '', //民族编号
					bq001007: '', //电话号码
					bq001006: '', //备用电话
					bq001032: '健在', //是否健在 健在，死亡
					bq0010322: '', //死亡时间
					bq0010323: '', //死亡原因
					bq001040: '', //入组日期
					bq001041: 1, //随访方案
					bq001042: '1', //随访状态
					bq001043: '', //主治医生编号
					bq001044: '', //主治医生姓名
					Bq001_001: '0', //患者编号
					Bq001_002: '', //患者姓名
					Bq001_018: '', //身份证号
					Bq001_003: '', //性别,1-男，2-女
					Bq001_004: '', //出生年月
					Bq001_012: '', //民族编号
					Bq001_007: '', //电话号码
					Bq001_006: '', //备用电话
					Bq001_032: '', //是否健在 健在，死亡
					Bq001_032_2: '', //死亡时间
					Bq001_032_3: '', //死亡原因
					Bq001_040: '', //入组日期
					Bq001_041: '', //入组方案
					Bq001_042: '1', //入组标识0-未入组，1-入组
					Bq001_043: '', //主治医生编号
					Bq001_044: '', //主治医生姓名不用
				},
				sempFiles: [],
				bq423: {},
				menuid: this.$utils.MenuEnum.useradd
			},
			form423: {
				bq423: {
					bq423003: '是', //确诊慢性HBV感染
					bq423004: '是', //年龄>=18岁
					bq423005: '是', //从未接受过HBV治疗
					bq423006: '是', //HBeAg阴性，HBeAb阳性
					bq423007: '是', //HBV DNA>2000 IU/mL
					bq423008: '是', //ALT<30 U/L（男性），ALT<19 U/L（女性）；且１年内连续检测３次，每次至少间隔３个月均满足以上条件
					bq423009: '是', //HBsAg>1000 IU/mL
					bq423010: '是', //前3个月肝穿刺病理肝组织炎症分级<G2或A2且肝组织纤维化分期<S2或F2，或肝脏瞬时弹性检测肝脏硬度值（LSM）
					bq423011: '是', //无肝硬化或肝癌家族史
					bq423012: '是', //患者能够理解并签署知情同意书
					bq423013: '否', //合并活动性甲肝、丙肝、丁肝、戊肝和/或 HIV 感染
					bq423014: '否', //甲胎蛋白超过正常值上限，或肝脏影像学检查提示肝脏肿瘤
					bq423015: '否', //腹部超声、CT、MRI或肝脏瞬时弹性检测提示既往或现患有肝硬化
					bq423016: '否', //最近1年内有酗酒（折合乙醇量男性≥40g/d，女性≥20g/d，或2 周内有大量饮酒史，折合乙醇量＞80g/d）或吸毒
					bq423017: '否', //近3个月内参加过其它药物临床试验
					bq423018: '否', //合并自身免疫性肝病
					bq423019: '否', //妊娠期、哺乳期妇女及近期准备生育
					bq423020: '否', //有严重心脏疾病史，包括6个月内有不稳定或未控制的心脏病
					bq423021: '否', //有精神疾病或精神疾病史
					bq423022: '否', //有未能控制的癫痫
					bq423023: '否', //有未控制的糖尿病、高血压、甲状腺疾病、视网膜病、自身免疫性疾病等
					bq423024: '否', //干扰素治疗前中性粒细胞计数<2×109/L和（或）血小板计数<100×109/L
					bq423025: '否', //研究者认为不能参加该临床试验者：
					Bq423_003: '是', //确诊慢性HBV感染
					Bq423_004: '是', //年龄>=18岁
					Bq423_005: '是', //从未接受过HBV治疗
					Bq423_006: '是', //HBeAg阴性，HBeAb阳性
					Bq423_007: '是', //HBV DNA>2000 IU/mL
					Bq423_008: '是', //ALT<30 U/L（男性），ALT<19 U/L（女性）；且１年内连续检测３次，每次至少间隔３个月均满足以上条件
					Bq423_009: '是', //HBsAg>1000 IU/mL
					Bq423_010: '是', //前3个月肝穿刺病理肝组织炎症分级<G2或A2且肝组织纤维化分期<S2或F2，或肝脏瞬时弹性检测肝脏硬度值（LSM）< 8 kPa
					Bq423_011: '是', //无肝硬化或肝癌家族史
					Bq423_012: '是', //患者能够理解并签署知情同意书
					Bq423_013: '否', //合并活动性甲肝、丙肝、丁肝、戊肝和/或 HIV 感染
					Bq423_014: '否', //甲胎蛋白超过正常值上限，或肝脏影像学检查提示肝脏肿瘤
					Bq423_015: '否', //腹部超声、CT、MRI或肝脏瞬时弹性检测提示既往或现患有肝硬化
					Bq423_016: '否', //最近1年内有酗酒（折合乙醇量男性≥40g/d，女性≥20g/d，或2 周内有大量饮酒史，折合乙醇量＞80g/d）或吸毒史
					Bq423_017: '否', //近3个月内参加过其它药物临床试验
					Bq423_018: '否', //合并自身免疫性肝病
					Bq423_019: '否', //妊娠期、哺乳期妇女及近期准备生育
					Bq423_020: '否', //有严重心脏疾病史，包括6个月内有不稳定或未控制的心脏病
					Bq423_021: '否', //有精神疾病或精神疾病史
					Bq423_022: '否', //有未能控制的癫痫
					Bq423_023: '否', //有未控制的糖尿病、高血压、甲状腺疾病、视网膜病、自身免疫性疾病等
					Bq423_024: '否', //干扰素治疗前中性粒细胞计数<2×109/L和（或）血小板计数<100×109/L
					Bq423_025: '否', //研究者认为不能参加该临床试验者：：
				},
			},
			showOverlay: false,
			//显示入组标准
			showInDialog: true,
			//是否显示入组日期
			showInDate: false,
			//保存接口
			saveUrl: this.$utils.Url.s400 + '/api/S400Bq001/Save',
			config: JSON.parse(sessionStorage.getItem("config")),
			sexList: [{
				id: "1",
				name: "男"
			}, {
				id: "2",
				name: "女"
			}],
			showInButton: false,
			//倒计时时间
			countDownTime: 10000,
		}
	},
	components: {
		...componentsModel
	},
	methods: {
		saveSucess: function () {
			//调用列表页的closeDialog方法conso

			// this.$emit("closeDialog", "")
			this.$router.push({
				name: "s400PatientList"
			})
		},
		addIn: function () {
			

		this.showInDialog = false
			// var that = this
			// let showflag = true
			// let showindex = 0
			// console.log(that.form423.bq423)
			// //遍历结果，是否显示入组日期
			// for (let key of Object.keys(that.form423.bq423)) {
			// 	if (key.indexOf('_') < 0) {
			// 		if (that.form423.bq423[key] == '否' && showindex < 10) { //前10个属性要为是						
			// 			showflag = false
			// 			that.form.bq001.bq001040 = ''
			// 		}
			// 		if (that.form423.bq423[key] == '是' && showindex >= 10) { //后面属性为否
			// 			showflag = false
			// 			that.form.bq001.bq001040 = ''
			// 		}
			// 		showindex++
			// 	}
			// }
			// if (!showflag) {
			// 	this.$dialog({
			// 		message: '不满足入组条件',
			// 	});
			// 	that.form.bq001.bq001040 = ''
			// }

			// //只有打开入组标准，填写好后，才放到保存数据的主体中
			// that.form423.bq423.BQ001_018 = that.form.bq001.bq001018
			// that.form.bq423 = that.form423.bq423
			// that.showInDate = showflag
			// that.showInDialog = false

		},
		//放弃入组
		closeIn: function () {
			this.$router.push({
				name: "s400PatientList"
			})
		},
		SaveInfo: function () {
			let that = this
			that.form.sempFiles = that.$refs.normalUpload.GetFileList()
			if (that.form.bq423.bq001018 != undefined) {
				//如果存在用户身份证，在保存前再取一次，防止修改身份证
				that.form.bq423.bq001018 = that.form.bq001.bq001018
			}
			that.$utils.CopyKeySave(that.form.bq001, that.form.bq001)
			that.$utils.CopyKeySave(that.form.bq423, that.form.bq423)

			//let ut = that.config.usertype.find(item=>item.id===that.form.bq001.bq001041).date
			//that.form.bq001.extend2 = ut[0].replace('周',' ')

			// if (that.form.bq001.bq001040 != '' && that.form.sempFiles.length == 0) {
			// 	that.$dialog({
			// 		message: '请上传知情同意书',
			// 	});
			// 	return
			// }
			that.$refs.btnSave.Save()
		},
		onSubmit(values) {
			console.log('submit', values);
		},
		OperIcard: function () {
			if (!this.isCardNo(this.form.bq001.bq001018)) {
				this.$dialog({
					message: '身份证号码不合法',
				});
				this.form.bq001.bq001018 = ''
				return
			}
			//显示性别和生日
			this.form.bq001.bq001003 = this.IdCard(this.form.bq001.bq001018, 2)
			this.form.bq001.bq001004 = this.IdCard(this.form.bq001.bq001018, 1)
		},
		isCardNo: function (idCard) {
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X 
			// var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
			// if (reg.test(card) === false) {
			// 	return false;
			// }
			// return true
			var ret = false;
			var w = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
			if (idCard.length == 18) {
				//身份证号码长度必须为18，只要校验位正确就算合法
				var crc = idCard.substring(17);
				var a = new Array();
				var sum = 0;
				for (var i = 0; i < 17; i++) {
					a.push(idCard.substring(i, i + 1));
					sum += parseInt(a[i], 10) * parseInt(w[i], 10);
					//alert(a[i]);
				}
				sum %= 11;
				var res = "-1";
				switch (sum) {
					case 0: {
						res = "1";
						break;
					}
					case 1: {
						res = "0";
						break;
					}
					case 2: {
						res = "X";
						break;
					}
					case 3: {
						res = "9";
						break;
					}
					case 4: {
						res = "8";
						break;
					}
					case 5: {
						res = "7";
						break;
					}
					case 6: {
						res = "6";
						break;
					}
					case 7: {
						res = "5";
						break;
					}
					case 8: {
						res = "4";
						break;
					}
					case 9: {
						res = "3";
						break;
					}
					case 10: {
						res = "2";
						break;
					}
				}
				if (crc.toLowerCase() == res.toLowerCase()) {
					ret = true;
				}
				//ret=true; 
			}
			/*
			else if(idCard.length == 15){
				 //15位的身份证号，只验证是否全为数字
				 var pattern = /\d/;
				 ret=pattern.test(idCard); 
			}*/
			return ret;

		},
		IdCard: function (IdCard, type) {
			if (type === 1) {
				//获取出生日期
				let birthday = IdCard.substring(6, 10) + "-" + IdCard.substring(10, 12) + "-" + IdCard.substring(
					12, 14)
				return birthday
			}
			if (type === 2) {
				//获取性别
				if (parseInt(IdCard.substr(16, 1)) % 2 === 1) {
					return "1"
				} else {
					return "2"
				}
			}
			if (type === 3) {
				//获取年龄
				var ageDate = new Date()
				var month = ageDate.getMonth() + 1
				var day = ageDate.getDate()
				var age = ageDate.getFullYear() - IdCard.substring(6, 10) - 1
				if (IdCard.substring(10, 12) < month || IdCard.substring(10, 12) === month && IdCard.substring(12,
					14) <= day) {
					age++
				}
				if (age <= 0) {
					age = 1
				}
				return age
			}
		},

	},
	mounted() {
		// 初始化时计算年龄
		if (this.form.bq001.bq001004) {
			this.form.bq001.extend3 = this.$utils.calculateAge(this.form.bq001.bq001004)
		}
		//当前登录人信息
		console.log(this.userModel)
		this.form.bq001.companyGuid = this.userModel.companyGuid
		this.form.bq001.departmentGuid = this.userModel.departmentGuid
		this.form.bq001.bq001043 = this.userModel.guid
		this.form.bq001.bq001044 = this.userModel.TrueName
		this.form.bq001.bq001007 = this.userModel.tel
	},
	watch: {
		"form.bq001.bq001002": function () {
			this.form.bq001.bq001002 = this.form.bq001.bq001002.toUpperCase()
		},
		"form.bq001.bq001004": function () {
			// 根据出生日期计算年龄
			if (this.form.bq001.bq001004 && this.form.bq001.bq001040) {
				this.form.bq001.extend3 = this.$utils.calculateAge(this.form.bq001.bq001004, this.form.bq001.bq001040)
			}
		},
		"form.bq001.bq001040": function () {
			// 根据出生日期计算年龄
			if (this.form.bq001.bq001004 && this.form.bq001.bq001040 ) {
				this.form.bq001.extend3 = this.$utils.calculateAge(this.form.bq001.bq001004, this.form.bq001.bq001040)
			}
		},
	}
}
</script>
<style scoped>
.divide-line {
	color: #1989fa;
	border-color: #1989fa;
	padding: 0 16px
}

.custom-title-enter {
	padding-right: 10px;
}
</style>
